import { useMemo, type CSSProperties } from 'react';
import { useSlidePanelWidth } from '@/hooks';

/**
 * Inline `--map-area-center-left` custom property that centers a floating
 * overlay in the visible configurator map area — to the left of the open
 * SlidePanel. Returns `undefined` (the CSS falls back to 50%) when no panel is
 * open (mobile / closed). Shared by the zoom pill and the drag hint so both
 * stay in sync.
 *
 * Container-relative (`100%` = the `.preview` width), unlike the main map's
 * viewport-relative {@link useMapCenterOffset}, which also accounts for the
 * navigation sidebar — the configurator preview sits behind no sidebar.
 */
export function useMapAreaCenterOffset(): CSSProperties | undefined {
  const panelWidth = useSlidePanelWidth();

  return useMemo(
    () =>
      panelWidth > 0
        ? ({
            '--map-area-center-left': `calc((100% - ${panelWidth}px) / 2)`,
          } as CSSProperties)
        : undefined,
    [panelWidth]
  );
}
